import { cn } from '@/lib/ui/style-helpers'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('animate-pulse rounded bg-main-background-neutral', className)} {...props} />
  )
}

export { Skeleton }
